export default "__VITE_ASSET__CQfMt8A9__"